import { PokerCardType } from 'components/cards/pokerCard';
import { PokerTournamentResponseApi } from 'lib/api/pokerCatalogResponseApi';
import { DatoCmsPokerSet } from 'lib/datoCms/types';
import { convertInImgType } from 'lib/datoCms/utils';

export const mergeCmsImageWithPokerCatalogList = (
  setImageFromCms: DatoCmsPokerSet[],
  catalogList: PokerTournamentResponseApi[] | undefined,
  urlParam: string
): PokerCardType[] | undefined => {
  return (
    catalogList &&
    catalogList.map((catalog) => {
      return {
        id: catalog.id,
        title: catalog.name,
        image: matchCatalogWithSetImage(catalog.name, setImageFromCms),
        slug: urlParam + catalog.slug,
        description: catalog.description,
      };
    })
  );
};

const matchCatalogWithSetImage = (name: string, setImageFromCms: any) => {
  const matchedImageSet = setImageFromCms.find((set: any) => {
    let regex = new RegExp(`${set.text}`, 'i');
    if (name.match(regex)) {
      return set.image;
    }
  });
  return matchedImageSet ? convertInImgType(matchedImageSet.image) : null;
};
